export enum QueryKeys {
	USERS = 'users',
	USER = 'user',
	ROLES = 'roles',
	PERMISSIONS = 'permissions',
	HOLIDAY = 'holiday',
	HOLIDAYS = 'holidays',
	DOCUMENTS = 'documents',
	DOCUMENT = 'document',
	DOCUMENT_COPIES = 'document-copies',
	DOCUMENT_COPY = 'document-copy',
	FATWAS = 'fatwas',
	FATWA = 'fatwa',
	ACTIVITIES = 'activities',
	ACTIVITY = 'activity',
	PAGES = 'pages',
	PAGE = 'page',
	LESSONS = 'lessons',
	LESSON = 'lesson',
	PUSH_NOTIFICATIONS = 'push-notifications',
	PUSH_NOTIFICATION = 'push-notification',
	EVENTS = 'events',
	EVENT = 'event',
	MEETING_PROTOCOLS = 'meeting-protocols',
	MEETING_PROTOCOL = 'meeting-protocol',
	ROOMS = 'rooms',
	ROOM = 'room',
	HOME_PAGE = 'home-page',
	PRAYER_TIMES = 'prayer-times',
	PRAYERS = 'prayers',
	PRAYER = 'prayer',
	VIDEOS = 'videos',
	VIDEO = 'video',
	ACTIONS = 'actions',
	ACTION = 'action',
	LEAVE_TIMES = 'leave-times',
	PROFILE = 'profile',
	TEACHER_OWN_COURSES = 'teacher-own-courses',
	ADMIN_GET_HOME = 'admin-get-home',
	ADMIN_GET_SCHOOLS = 'admin-get-schools',
	TEACHER_GET_HOME = 'teacher-get-home',
	TEACHER_OWN_COURSE = 'teacher-own-course',
	TEACHER_STUDENTS = 'teacher-students',
	TEACHER_STUDENTS_SESSIONS = 'teacher-students-sessions',
	TEACHER_STUDENTS_ATTENDANCE = 'teacher-students-attendance',
	TEACHER_STUDENTS_HOMEWORK = 'teacher-students-homework',
	CHECK_SESSION = 'check-session',
	MISTAKES_CATEGORIES = 'mistakes-categories',
	STUDENT_MISTAKES = 'student-mistakes',
	COMPLETED_LESSONS = 'completed-lessons',
	FAQS = 'faqs',
	STUDENT_GET_HOME = 'student-get-home',
	STUDENT_GET_DETAIL = 'student-get-detail',
	STUDENT_GET_SUBSCRIBER = 'student-get-subscriber',
	CATEGORY_CONTENTS = 'category-contents',
	STUDENT_GET_MARKS = 'student-get-marks',
	PATHS = 'paths',
	PROGRAMS = 'programs',
	SCHOOLS = 'schools',
	SCHOOL_PROGRAMS = 'school-programs',
	PROGRAM_TEACHERS = 'program-teachers',
	PROGRAM_TEACHER_TIMES = 'program-teacher-times',
	STUDENT_HOME_WORKS = 'student-home-works',
	TICKET = 'ticket',
	TICKET_COMMENTS = 'ticket-comments',
	PLANS = 'plans',
	PLAN = 'plan',
	KORAN_PAGE = 'koran-page',
	COUNTRIES = 'countries',
	PAY_DATA = 'pay-data',
	MY_ACCOUNTS = 'my-accounts',
	GET_ME_SEMINARS = 'get-me-seminars',
	GET_ONE_SEMINAR = 'get-one-seminar',
	ADMIN_GET_ME_SEMINARS = 'admin-get-me-seminars',
	ADMIN_GET_ONE_SEMINAR = 'admin-get-one-seminar',
	PROGRAM_PAYMENT_WAYS = 'program-payment-ways',
	PATH_LEVELS = 'path-levels',
	MUSHAF_PAGE = 'mushaf-page',
	SESSION_INFO = 'session-info',
}
